<template>
<div class="quiz">
	<progress-bar
		:questionIndex="questionIndex"
		:countQuestions="questionList.length"
	/>
	<div v-for="(question, index) in questionList" :key="index">
		<first-question
			v-if="index == 0 && questionIndex == 0"
			:question="question"
			v-model="userResponses[index]"
		/>
		<second-question
			v-if="index == 1 && questionIndex == 1"
			:question="question"
			v-model="userResponses[index]"
		/>
		<third-question
			v-if="index == 2 && questionIndex == 2"
			:question="question"
			v-model="userResponses[index]"
		/>
		<fourth-question
			v-if="index == 3 && questionIndex == 3"
			:question="question"
			v-model="userResponses[index]"
		/>
		<fifth-question
			v-if="index == 4 && questionIndex == 4"
			:question="question"
			v-model="userResponses[index]"
		/>
	</div>
	<hr>
	<grid>
		<grid-item size="1/1">
			<router-link class="button primary register-button"
				to="/"
				v-if="questionIndex === questionList.length - 1"
			>
				Finish
			</router-link>
			<a :class="'button primary register-button ' + (userResponses[questionIndex] == null ? 'isDisabled' : '')"
				@click="next"
				v-else
			>
				Next
			</a>
		</grid-item>
	</grid>
</div>
</template>

<script>
import ProgressBar from './ProgressBar'
import FirstQuestion from './FirstQuestion'
import SecondQuestion from './SecondQuestion'
import ThirdQuestion from './ThirdQuestion'
import FourthQuestion from './FourthQuestion'
import FifthQuestion from './FifthQuestion'

export default {
	components: {
		ProgressBar,
		FirstQuestion,
		SecondQuestion,
		ThirdQuestion,
		FourthQuestion,
		FifthQuestion
	},
	data: () => ({
		questionIndex: 0,
		userResponses: [],
		questionList: [
		{
			text: "I am using the irys investment promotion platform for",
			responses: [
				{
					text: 'Investment desicion-making'
				},
				{
					text: 'Academic / Policy research'
				},
			]
		},
		{
			text: "Which best describes the type of investment you are seeking to make?",
			responses: [
				{text: 'I am not considering an investment'},
				{text: 'Establishing of a joint venture / PPP'},
				{text: 'Acquisition of a foreign company'},
				{text: 'Building or Establishing a new plant / operation'},
				{text: 'Establishing of a Representative company owned by investing company'},
			]
		},
		{
			text: "Which sectors are of interest to you? \n Select up to 5",
			responses: [
				{text: 'Agriculture'}, {text: 'Agro-industry'}, {text: 'Animal Husbandry'},
				{text: 'Automotive'}, {text: 'Bulding materials'}, {text: 'Chemicals'},
				{text: 'Communications infrastructure'}, {text: 'Construction'},
				{text: 'Agriculture'}, {text: 'Agro-industry'}, {text: 'Animal Husbandry'},
				{text: 'Automotive'}, {text: 'Bulding materials'}, {text: 'Chemicals'},
				{text: 'Communications infrastructure'}, {text: 'Construction'},
				{text: 'Agriculture'}, {text: 'Agro-industry'}, {text: 'Animal Husbandry'},
				{text: 'Automotive'}, {text: 'Bulding materials'}, {text: 'Chemicals'},
				{text: 'Communications infrastructure'}, {text: 'Construction'}
			]
		},
		{
			text: "Your organization typically makes investments of the scale:",
			responses: [
				{text: '< $100,000'},
				{text: '$100,000 - $500,000'},
				{text: '$500,000 - $1,000,000'},
				{text: '$1,000,000 - $5,000,000'},
				{text: '$5,000,000 - $10,000,000'},
				{text: '$10,000,000+'},
				{text: 'Not Applicable'},
			]
		},
		{
			text: "At what stage of the investment decision making process are you?",
			responses: [
				{text: 'I am not considering an investment'},
				{text: 'Very early stage / general ivestigation'},
				{text: 'Early stage / some field investigation'},
				{text: 'Intermediate / conducting formal decision'},
				{text: 'Advanced / final investment decision'},
				{text: 'Implementation'},
			]
		}
		]
	}),
	methods: {
		next: function() {
			this.questionIndex++
		}
	}
}
</script>

<style lang="scss">
.quiz {
	.question-text {
		background-color: rgba(29, 35, 42, 0.8);
		color: #fff;
		font-size: 13px;
		padding: 10px 80px;
		margin-bottom: 7px;
		outline: none;
		font-weight: 400;
		text-transform: uppercase;
	}
	label {
		cursor: pointer;
		display: block;
		background-color: #edece3;
		color: #4e4e4e;

		&:hover {
			background-color: #eeece3;
			font-weight: 700;
		}
		span {
			line-height: normal;
			display: inline-block;
			vertical-align: middle;
			font-size: 12px;
			text-transform: uppercase;
			user-select: none;
		}
	}
	label.active {
		background-color: #141921;
		color: #fff;
		font-weight: 400;
		cursor: auto;
	}
}
</style>
